export default "__VITE_ASSET__ce64057f__"